function withEndingSlash(endpoint) {
  const d = endpoint && endpoint[endpoint.length - 1] !== '/' ? '/' : '';
  return `${endpoint}${d}`;
}

export function actionWith(action, status, payload) {
  return Object.assign({}, action, { status: status }, payload);
}

export function defaultGetAction(type, endpoint) {
  return (queryParams) => dispatch => dispatch({
    type,
    request: {
      method: 'GET',
      endpoint: withEndingSlash(endpoint),
      queryParams
    }
  });
}

export function createReducer(initialState, reducerMap) {
  return (state, action) => {
    if (!state) {
      state = initialState;
    }
    const reducer = reducerMap[action.type];

    return reducer ? reducer(Object.assign({}, state), action) : state;
  };
}

export function createRequestReducer(state, action, reducerMap) {
  const reducer = reducerMap[action.status];

  return reducer ? reducer(state, action) : state;
}

export function createDefaultListInitialState(obj) {
  return Object.assign({
    items: [],
    queryParams: null,
    count: null,
    nextPage: null,
    pageCount: null,
    pageNumber: null,
    previousPage: null,
    isFetching: false,
    fetchingErrors: null
  }, obj);
}

export function createDefaultGetListReducer(state, action, reducerMap = {}) {
  return createRequestReducer(state, action, {
    SEND: (state) => {
      const newState = Object.assign({}, state, {
        queryParams: action.request.queryParams,
        isFetching: true,
        fetchingErrors: null
      });

      return reducerMap.AFTER_SEND ? reducerMap.AFTER_SEND(newState) : newState;
    },

    SUCCESS: (state, action) => {
      let newState = Object.assign({}, state);

      if (state.queryParams === action.request.queryParams) {
        const { response } = action.request;

        newState = Object.assign({}, state, {
          items: response.results,
          count: response.count,
          nextPage: response.nextPage,
          pageCount: response.pageCount,
          pageNumber: response.pageNumber,
          previousPage: response.previousPage,
          isFetching: false
        });
      }

      return reducerMap.AFTER_SUCCESS ? reducerMap.AFTER_SUCCESS(newState) : newState;
    },

    FAIL: (state, action) => {
      const newState = Object.assign({}, state, {
        isFetching: false,
        fetchingErrors: action.request.error
      });

      return reducerMap.AFTER_FAIL ? reducerMap.AFTER_FAIL(newState) : newState;
    }
  });
}



// WEBPACK FOOTER //
// ./src/utils/redux.js